export const findSubPromotors = (dataArray) => {
  const subPromotor = dataArray.filter((tallyRecord) => {
    if (tallyRecord[1].adminPromotorId) {
      return tallyRecord;
    }
  });
  return subPromotor;
};
